import { Component, Input } from '@angular/core';
import { ChartType } from '@ddt-web/chart';
import { TabData } from '@ddt-web/data-service';

@Component({
	selector: 'aa-asset-allocation-slim',
	templateUrl: './asset-allocation-slim.component.html',
	styleUrls: ['../asset-allocation/asset-allocation.component.scss']
})

export class AssetAllocationSlimComponent {
	@Input() public type: ChartType = ChartType.Column;
	@Input() public tab: TabData;
	@Input() public customChartAttributes = {}; // Used to override default chart properties like tickPosition,numberOfTicks etc
	@Input() public name: string = 'exposure'; // For ex: 'center-align chart' which is used by bfa-chart to override specific chart properties
}
